import type { PrismicConfig } from '@landsbankinn/prismic';
import { prismicConfic } from '@landsbankinn/prismic';

const parseBoolean = (str?: string) => {
  if (!str) {
    return false;
  }
  try {
    return Boolean(JSON.parse(str));
  } catch (err) {
    return false;
  }
};

const DEFAULT_REVALIDATION = 1 * 60;

interface WebsiteConfig extends PrismicConfig {
  LANDSBANKINN_API_KEY?: string;
  DEVELOPMENT: boolean;
  FACEBOOK_PIXEL?: string;
  GOOGLE_ANALYTICS?: string;
  GTM_ID?: string;
  LANDSBANKINN_GRAPHQL_URL?: string;
  SKIP_ARTICLES: boolean;
  NO_BASE64_IMAGES: boolean;
  CANONICAL_URL_BASE?: string;
  REVALIDATION_TIMEOUT: number;
}

export const Config: WebsiteConfig = {
  ...prismicConfic,
  DEVELOPMENT: process.env.NODE_ENV === 'development',
  REVALIDATION_TIMEOUT: DEFAULT_REVALIDATION,
  FACEBOOK_PIXEL: process.env.NEXT_PUBLIC_FACEBOOK_PIXEL,
  GOOGLE_ANALYTICS: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS,
  GTM_ID: process.env.GTM_ID || 'GTM-PPRB4J',
  LANDSBANKINN_API_KEY: process.env.NEXT_PUBLIC_LANDSBANKINN_API_KEY,
  LANDSBANKINN_GRAPHQL_URL: process.env.NEXT_PUBLIC_LANDSBANKINN_GRAPHQL_URL,
  SKIP_ARTICLES: parseBoolean(
    process.env.SKIP_ARTICLES ?? process.env.NEXT_PUBLIC_SKIP_ARTICLES,
  ),
  NO_BASE64_IMAGES: parseBoolean(
    process.env.NO_BASE64_IMAGES ?? process.env.NEXT_PUBLIC_NO_BASE64_IMAGES,
  ),
  CANONICAL_URL_BASE:
    process.env.NEXT_PUBLIC_CANONICAL_URL_BASE ||
    'https://arsskyrsla.landsbankinn.is',
};
